export const AUTH_ENABLED = process.env.REACT_APP_AUTH_ENABLED === 'true';
export const CART_ENABLED = process.env.REACT_APP_CART_ENABLED === 'true';
export const ORDERS_ENABLED = process.env.REACT_APP_ORDERS_ENABLED === 'true';
export const CONTACT_FORM_ENABLED = process.env.REACT_APP_CONTACT_FORM_ENABLED === 'true';
export const REVIEWS_ENABLED = process.env.REACT_APP_REVIEWS_ENABLED === 'true';
export const COOKIE_NOTICE_ENABLED = process.env.REACT_APP_COOKIE_NOTICE_ENABLED === 'true';
export const CITY_STORAGE_ENABLED = process.env.REACT_APP_CITY_STORAGE_ENABLED === 'true';
